import React, { useCallback, useMemo } from "react";
import classNames from "classnames";

import ClearIcon from "../../../Icon/Clear";
import InputGroup from "../../InputGroup";
import { TextInput } from "../Input";
import { InputPropTypes } from "../../../propTypes";

import "./styles.scss";

const Search = ({
  input,
  value,
  onChange,
  disabled,
  rounded,
  readonly,
  type,
  ...rest
}) => {
  const inputValue = useMemo(() => (input ? input.value : value), [
    input,
    value,
  ]);
  const onChangeFn = useMemo(() => input?.onChange || onChange, [
    input,
    onChange,
  ]);
  const inputType = useMemo(() => (type === "search" ? "text" : type), [type]);

  const onClearClick = useCallback(() => {
    if (onChangeFn) {
      onChangeFn("");
    }
  }, [onChangeFn]);

  const append = useMemo(() => {
    return (
      <div onClick={onClearClick} className="icon">
        <ClearIcon />
      </div>
    );
  }, [onClearClick]);

  return (
    <InputGroup
      className={classNames("mydpd-search-control", rounded && "rounded")}
      append={inputValue && !disabled && !readonly ? append : null}
    >
      <TextInput
        input={input}
        type={inputType}
        value={value}
        onChange={onChange}
        disabled={disabled}
        rounded={rounded}
        readonly={readonly}
        {...rest}
      />
    </InputGroup>
  );
};

Search.propTypes = InputPropTypes;

export default Search;
